import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import debug from '../services/debug';

ReactGA.initialize('UA-XXXX');

const AppHOC = (WrappedComponent, options = {}) => {
    const trackPage = (page) => {
        debug('trackPage', page);
        ReactGA.set({
            page,
            ...options,
        });
        ReactGA.pageview(page);
    };

    const HOC = class extends Component {
        componentDidMount() {
            const { location: { pathname } } = this.props;
            trackPage(pathname);
        }

        componentDidUpdate(nextProps) {
            const { location: { pathname } } = this.props;
            const nextPage = nextProps.location.pathname;

            if (pathname !== nextPage) {
                // Scroll to the top of the new page
                window.scrollTo(0, 0);
                // Track page in Google Analytics
                trackPage(nextPage);
            }
        }

        render() {
            // eslint-disable-next-line react/jsx-props-no-spreading
            return <WrappedComponent {...this.props} />;
        }
    };

    HOC.propTypes = {
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }).isRequired,
    };

    return HOC;
};

export default AppHOC;
